const actions = {
  SET_STATE: 'request/SET_STATE',
  FETCH_ALL_REQUESTS: 'request/FETCH_ALL_REQUESTS',
  FETCH_SINGLE_REQUEST: 'request/FETCH_SINGLE_REQUEST',
  UPDATE_SINGLE_REQUEST: 'request/UPDATE_SINGLE_REQUEST',
}

export default actions
